var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCalendar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "82063EC8-C3FE-4AA7-9F6C-EC1BB15FA96E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,10.0000832 L3.33333333,16.6666665 L16.6666667,16.6666665 L16.6666667,10.0000832 L3.33333333,10.0000832 Z M3.33333333,8.33341658 L16.6666667,8.33341658 L16.6666667,5.83333313 L3.33333333,5.83333313 L3.33333333,8.33341658 Z M1.66666667,18.3333333 L1.66666667,4.16666667 L18.3333333,4.16666667 L18.3333333,18.3333333 L1.66666667,18.3333333 Z M4.99974996,3.33341658 L3.33308329,3.33341658 L3.33308329,1.66674991 L4.99974996,1.66674991 L4.99974996,3.33341658 Z M16.6664163,3.33341658 L14.9997497,3.33341658 L14.9997497,1.66674991 L16.6664163,1.66674991 L16.6664163,3.33341658 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-team-overview-details-hover",
    transform: "translate(-161.000000, -2093.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-skills",
    transform: "translate(100.000000, 1911.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_calendar",
    transform: "translate(20.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#191919",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_calendar.5185e7dbf23c31b8da881a0762c5dc38.svg";